import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة العد التنازلي لعيد الميلاد - كم باقي على عيد ميلادي";
const DESCRIPTION =
  "احسب كم باقي على عيد ميلادك بالضبط! حاسبة العد التنازلي لعيد الميلاد تعرض الوقت المتبقي بالأشهر والأيام والساعات والدقائق والثواني. اكتشف متى عيد ميلادك القادم واستعد للاحتفال";
const KEYWORDS =
  "كم باقي على عيد ميلادي, حاسبة عيد الميلاد, العد التنازلي لعيد الميلاد, حساب الوقت المتبقي على عيد الميلاد, متى عيد ميلادي, حساب عيد ميلادي القادم, الوقت المتبقي للعيد, عداد عيد الميلاد";
const OG_URL = "https://do-calculate.com/calculator/ar/birthday/";
// JSON-LD Schema for SEO
const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "حاسبة العد التنازلي لعيد الميلاد",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "الرئيسية",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "الحاسبات",
        item: "https://do-calculate.com/ar/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "حاسبة عيد الميلاد",
        item: OG_URL,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "كيف أعرف كم باقي على عيد ميلادي؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "أدخل تاريخ ميلادك في الحاسبة وستحصل فوراً على العد التنازلي الدقيق لعيد ميلادك القادم بالأشهر والأيام والساعات والدقائق والثواني.",
        },
      },
      {
        "@type": "Question",
        name: "هل يتم تحديث العداد تلقائياً؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "نعم، يتم تحديث العداد تلقائياً كل ثانية ليعرض لك الوقت المتبقي بدقة متناهية حتى لحظة عيد ميلادك.",
        },
      },
    ],
  },
];

const GREGORIAN_MONTHS = [
  "يناير / كانون الثاني", "فبراير / شباط", "مارس / آذار", "أبريل / نيسان",
  "مايو / أيار", "يونيو / حزيران", "يوليو / تموز", "أغسطس / آب",
  "سبتمبر / أيلول", "أكتوبر / تشرين الأول", "نوفمبر / تشرين الثاني", "ديسمبر / كانون الأول"
];

const DAYS_OF_WEEK = ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"];


function AgeCalculatorGregorian() {
  // 1. تعريف الحالة للقوائم المنسدلة
  const [birthDateInput, setBirthDateInput] = useState({
    day: "1",
    month: "1",
    year: "1990"
  });

  const [countdown, setCountdown] = useState(null);
  const [error, setError] = useState(null);
  const [isToday, setIsToday] = useState(false);

  // 2. تعديل دالة الحساب لتستخدم القيم من القوائم
  const calculateCountdown = () => {
    // تركيب التاريخ من الاختيارات
    const selectedDate = new Date(
      parseInt(birthDateInput.year),
      parseInt(birthDateInput.month) - 1, // الأشهر في JS تبدأ من 0
      parseInt(birthDateInput.day)
    );

    if (isNaN(selectedDate.getTime())) {
      setError("تاريخ غير صالح. يُرجى التأكد من الأيام (مثلاً 31 فبراير غير موجود)");
      setCountdown(null);
      return;
    }

    updateCountdown(selectedDate);
  };

  const updateCountdown = (birthDate) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const birthMonth = birthDate.getMonth();
    const birthDay = birthDate.getDate();

    let nextBirthday = new Date(currentYear, birthMonth, birthDay);
    if (nextBirthday < currentDate) {
      nextBirthday.setFullYear(currentYear + 1);
    }

    const today = new Date();
    const isBirthdayToday = today.getDate() === birthDay && today.getMonth() === birthMonth;
    setIsToday(isBirthdayToday);

    if (isBirthdayToday) {
      setCountdown({
        isBirthday: true,
        nextBirthdayDate: nextBirthday.toLocaleDateString("ar-EG", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
        dayOfWeek: DAYS_OF_WEEK[nextBirthday.getDay()],
        age: currentYear - birthDate.getFullYear(),
      });
      setError(null);
      return;
    }

    const remainingTime = nextBirthday - currentDate;
    const totalSeconds = Math.floor(remainingTime / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);

    let months = nextBirthday.getMonth() - currentDate.getMonth();
    let days = nextBirthday.getDate() - currentDate.getDate();
    if (days < 0) {
      months--;
      const lastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
      days += lastMonth.getDate();
    }
    if (months < 0) months += 12;

    setCountdown({
      isBirthday: false,
      months, days,
      hours: totalHours % 24,
      minutes: totalMinutes % 60,
      seconds: totalSeconds % 60,
      totalDays, totalHours, totalMinutes, totalSeconds,
      nextBirthdayDate: nextBirthday.toLocaleDateString("ar-EG", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      dayOfWeek: DAYS_OF_WEEK[nextBirthday.getDay()],
      ageOnNextBirthday: nextBirthday.getFullYear() - birthDate.getFullYear(),
      weeksRemaining: Math.floor(totalDays / 7),
    });
    setError(null);
  };

  // 3. تحديث الـ useEffect ليراقب التاريخ المختار
  useEffect(() => {
    let interval;
    if (countdown && !countdown.isBirthday) {
      const selectedDate = new Date(
        parseInt(birthDateInput.year),
        parseInt(birthDateInput.month) - 1,
        parseInt(birthDateInput.day)
      );
      interval = setInterval(() => {
        updateCountdown(selectedDate);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [birthDateInput, countdown]);
  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>
              حاسبة العد التنازلي لعيد الميلاد
            </h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>حاسبة العد التنازلي لعيد الميلاد</strong> تساعدك على
                معرفة الوقت المتبقي بالضبط على عيد ميلادك القادم! أدخل تاريخ
                ميلادك واحصل على عداد تنازلي دقيق يعرض الأشهر والأيام والساعات
                والدقائق والثواني المتبقية. استعد للاحتفال بيومك الخاص واعرف
                متى تبدأ التحضيرات!
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            {/* Calculator Section */}
            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>
                  اكتشف كم باقي على عيد ميلادك
                </h2>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <label ><strong>أدخل تاريخ ميلادك:</strong></label>
                  <div className="d-flex gap-2 flex-wrap">
                    {/* اليوم */}
                    <select
                      className="form-control flex-grow-1"
                      value={birthDateInput.day}
                      onChange={(e) => setBirthDateInput({ ...birthDateInput, day: e.target.value })}
                    >
                      {Array.from({ length: 31 }, (_, i) => i + 1).map(d => (
                        <option key={d} value={d}>{d}</option>
                      ))}
                    </select>

                    {/* الشهر */}
                    <select
                      className="form-control flex-grow-1"
                      value={birthDateInput.month}
                      onChange={(e) => setBirthDateInput({ ...birthDateInput, month: e.target.value })}
                    >
                      {GREGORIAN_MONTHS.map((m, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>
                      ))}
                    </select>

                    {/* السنة */}
                    <select
                      className="form-control flex-grow-1"
                      value={birthDateInput.year}
                      onChange={(e) => setBirthDateInput({ ...birthDateInput, year: e.target.value })}
                    >
                      {Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i).map(y => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <br />
              <div className="text-center mb-3 mt-4">
                <button
                  className="btn btn-success btn-lg"
                  style={{ fontSize: "18px", padding: "10px 40px" }}
                  onClick={calculateCountdown}
                >
                  ابدأ العد التنازلي
                </button>
              </div>
              {error && (
                <div className="alert alert-warning" role="alert">
                  <strong>تنبيه:</strong> {error}
                </div>
              )}
              {countdown && countdown.isBirthday && (
                <div
                  className="alert alert-success text-center"
                  style={{ fontSize: "18px" }}
                >
                  <h3 style={{ fontSize: "24px", marginBottom: "15px" }}>
                    🎉 عيد ميلاد سعيد! 🎂
                  </h3>
                  <p style={{ fontSize: "20px" }}>
                    اليوم هو عيد ميلادك! عامك الجديد رقم {countdown.age}
                  </p>
                  <p style={{ fontSize: "16px" }}>
                    عيد ميلادك القادم سيكون يوم: {countdown.nextBirthdayDate}
                  </p>
                </div>
              )}
              {countdown && !countdown.isBirthday && (
                <div className="alert alert-info" style={{ fontSize: "16px" }}>
                  <h3
                    style={{
                      fontSize: "20px",
                      marginBottom: "20px",
                      textAlign: "center",
                    }}
                  >
                    <strong>⏰ العد التنازلي لعيد ميلادك</strong>
                  </h3>
                  <div
                    className="p-4 mb-3 bg-light rounded text-center"
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      color: "#155724",
                    }}
                  >
                    {countdown.months > 0 && (
                      <span>
                        {countdown.months} شهر و{" "}
                      </span>
                    )}
                    {countdown.days} يوم و {countdown.hours} ساعة
                    <br />و {countdown.minutes} دقيقة و {countdown.seconds}{" "}
                    ثانية
                  </div>
                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>معلومات تفصيلية عن عيد ميلادك القادم</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>
                            📅 <strong>التاريخ:</strong>{" "}
                            {countdown.nextBirthdayDate}
                          </li>
                          <li>
                            📆 <strong>اليوم:</strong> {countdown.dayOfWeek}
                          </li>
                          <li>
                            🎂 <strong>ستبلغ من العمر:</strong>{" "}
                            {countdown.ageOnNextBirthday} سنة
                          </li>
                          <li>
                            ⏱️ <strong>الأيام المتبقية:</strong>{" "}
                            {countdown.totalDays} يوم
                          </li>
                          <li>
                            📊 <strong>الأسابيع المتبقية:</strong>{" "}
                            {countdown.weeksRemaining} أسبوع
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>إحصائيات إضافية</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>
                            ⏰ إجمالي الساعات المتبقية:{" "}
                            {countdown.totalHours.toLocaleString()} ساعة
                          </li>
                          <li>
                            ⏰ إجمالي الدقائق المتبقية:{" "}
                            {countdown.totalMinutes.toLocaleString()} دقيقة
                          </li>
                          <li>
                            ⏰ إجمالي الثواني المتبقية:{" "}
                            {countdown.totalSeconds.toLocaleString()} ثانية
                          </li>
                          <li>
                            📈 نسبة الوقت المتبقي من السنة:{" "}
                            {countdown.yearProgress}%
                          </li>
                        </ul>
                        <div
                          className="alert alert-success mt-3"
                          style={{ fontSize: "14px" }}
                        >
                          <strong>💡 نصيحة:</strong> احفظ هذه الصفحة في
                          المفضلة لتتابع العد التنازلي في أي وقت!
                        </div>
                      </div>
                    </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>أفكار للاحتفال بعيد ميلادك</strong>
                      </div>
                      <div className="info-section-body">
                        <p style={{ lineHeight: "1.8" }}>
                          مع اقتراب عيد ميلادك، إليك بعض الأفكار للاحتفال:
                        </p>
                        <ul style={{ lineHeight: "1.8" }}>
                          <li>🎈 نظم حفلة مع العائلة والأصدقاء</li>
                          <li>🎁 حضّر قائمة بالهدايا المفضلة</li>
                          <li>🍰 احجز كعكة عيد ميلاد مميزة</li>
                          <li>📸 خطط لجلسة تصوير تذكارية</li>
                          <li>✈️ خطط لرحلة قصيرة أو نشاط خاص</li>
                          <li>💌 أرسل دعوات للأحباب</li>
                          <li>🎉 حضّر ديكورات وأجواء احتفالية</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            {/* Related Links */}
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Informational Content */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>ما هي حاسبة العد التنازلي لعيد الميلاد؟</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>حاسبة العد التنازلي لعيد الميلاد</strong> هي أداة
                  إلكترونية متطورة تساعدك على معرفة الوقت المتبقي بالضبط على عيد
                  ميلادك القادم. تعمل الحاسبة بشكل تلقائي وتحدّث العداد كل
                  ثانية لتعرض لك:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>عدد الأشهر المتبقية</li>
                  <li>عدد الأيام المتبقية</li>
                  <li>عدد الساعات المتبقية</li>
                  <li>عدد الدقائق المتبقية</li>
                  <li>عدد الثواني المتبقية</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  مميزات الحاسبة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>تحديث تلقائي:</strong> العداد يتحدث كل ثانية تلقائياً
                  </li>
                  <li>
                    <strong>دقة عالية:</strong> حسابات دقيقة بالثانية
                  </li>
                  <li>
                    <strong>معلومات شاملة:</strong> تفاصيل كاملة عن عيد ميلادك
                    القادم
                  </li>
                  <li>
                    <strong>سهولة الاستخدام:</strong> واجهة بسيطة وواضحة
                  </li>
                  <li>
                    <strong>تنبيه خاص:</strong> رسالة تهنئة إذا كان اليوم عيد
                    ميلادك
                  </li>
                </ul>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 فكرة:</strong> يمكنك استخدام الحاسبة لمعرفة كم باقي
                  على أعياد ميلاد أحبائك أيضاً!
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>لماذا نحتفل بأعياد الميلاد؟</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  عيد الميلاد هو مناسبة خاصة للاحتفال بيوم ولادتك وبمرور عام جديد
                  من حياتك. للاحتفال بأعياد الميلاد أهمية كبيرة:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  الأهمية النفسية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>الشعور بالتقدير:</strong> الاحتفال يشعرك بأنك مميز
                    ومحبوب
                  </li>
                  <li>
                    <strong>تعزيز الثقة بالنفس:</strong> يوم خاص بك فقط يعزز
                    إحساسك بقيمتك
                  </li>
                  <li>
                    <strong>ذكريات جميلة:</strong> خلق ذكريات سعيدة تدوم طوال
                    العمر
                  </li>
                  <li>
                    <strong>التأمل والتقييم:</strong> فرصة للنظر إلى ما حققته
                    والتخطيط للمستقبل
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  الأهمية الاجتماعية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>تقوية الروابط:</strong> جمع الأحباء والعائلة
                  </li>
                  <li>
                    <strong>التعبير عن الحب:</strong> فرصة للآخرين لإظهار اهتمامهم
                  </li>
                  <li>
                    <strong>التقاليد العائلية:</strong> نقل العادات والتقاليد
                    للأجيال
                  </li>
                  <li>
                    <strong>اللحظات السعيدة:</strong> خلق أجواء من الفرح والسعادة
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  فوائد الاحتفال:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>تحسين الحالة المزاجية والنفسية</li>
                  <li>تقوية العلاقات الاجتماعية</li>
                  <li>خلق ذكريات إيجابية</li>
                  <li>الشعور بالامتنان للحياة</li>
                  <li>فرصة للتخطيط والتطور الشخصي</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>أفكار مبتكرة للاحتفال بعيد الميلاد</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  احتفالات تقليدية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>حفلة منزلية:</strong> دعوة الأصدقاء والعائلة للمنزل
                  </li>
                  <li>
                    <strong>عشاء في مطعم:</strong> اختر مطعمك المفضل
                  </li>
                  <li>
                    <strong>كعكة عيد ميلاد:</strong> احصل على كعكة مميزة بتصميم
                    خاص
                  </li>
                  <li>
                    <strong>الهدايا:</strong> استقبل الهدايا من الأحباء
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  أفكار مبتكرة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>رحلة قصيرة:</strong> قضاء عطلة نهاية أسبوع في مكان
                    جديد
                  </li>
                  <li>
                    <strong>مغامرة جديدة:</strong> تجربة نشاط لم تجربه من قبل
                    (قفز بالمظلات، غوص، إلخ)
                  </li>
                  <li>
                    <strong>يوم سبا:</strong> تدليل نفسك بيوم استرخاء كامل
                  </li>
                  <li>
                    <strong>فعل خيري:</strong> التطوع أو التبرع في يوم ميلادك
                  </li>
                  <li>
                    <strong>حفلة بموضوع معين:</strong> حفلة تنكرية أو بثيم خاص
                  </li>
                  <li>
                    <strong>جلسة تصوير احترافية:</strong> توثيق هذه اللحظة
                    بصور جميلة
                  </li>
                  <li>
                    <strong>تجربة طهي:</strong> ورشة طبخ أو تحضير وجبة خاصة
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  احتفالات افتراضية (للمسافرين أو في ظروف خاصة):
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>حفلة فيديو عبر الإنترنت مع الأحباء البعيدين</li>
                  <li>ألعاب جماعية عبر الإنترنت</li>
                  <li>مشاهدة فيلم مفضل مع الأصدقاء عن بُعد</li>
                  <li>إرسال وتلقي الهدايا الرقمية</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  احتفالات للأطفال:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>حفلة بشخصيات كرتونية</li>
                  <li>ألعاب وأنشطة ترفيهية</li>
                  <li>عرض سحري أو مهرّج</li>
                  <li>حديقة الملاهي أو الألعاب</li>
                  <li>ورشة فنية أو حرفية</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>التخطيط المسبق لعيد الميلاد</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  التخطيط المسبق يضمن احتفالاً ناجحاً ومميزاً. إليك دليل زمني
                  للتحضير:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  قبل شهر من عيد الميلاد:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>حدد نوع الاحتفال الذي تريده</li>
                  <li>ضع قائمة بالمدعوين</li>
                  <li>اختر المكان (منزل، مطعم، قاعة، إلخ)</li>
                  <li>حدد الميزانية</li>
                  <li>ابدأ بالبحث عن الخدمات المطلوبة</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  قبل أسبوعين:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>أرسل الدعوات للضيوف</li>
                  <li>احجز المكان أو المطعم</li>
                  <li>اطلب كعكة عيد الميلاد</li>
                  <li>اشترِ الديكورات</li>
                  <li>خطط لقائمة الطعام</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  قبل أسبوع:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>أكد الحجوزات</li>
                  <li>اشترِ مستلزمات الطعام</li>
                  <li>جهّز قائمة الأغاني المفضلة</li>
                  <li>خطط للأنشطة والألعاب</li>
                  <li>تأكد من عدد الحاضرين</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  قبل يوم:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>نظّف المكان</li>
                  <li>حضّر بعض الأطعمة مسبقاً</li>
                  <li>رتب الديكورات</li>
                  <li>جهّز كاميرا التصوير</li>
                  <li>اعتنِ بمظهرك الشخصي</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  يوم عيد الميلاد:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>رتب الديكورات النهائية</li>
                  <li>حضّر الطعام</li>
                  <li>استقبل الضيوف بحرارة</li>
                  <li>استمتع باللحظة ولا تنسَ التقاط الصور!</li>
                </ul>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ نصيحة ذهبية:</strong> استخدم حاسبة العد التنازلي
                  لتتبع الوقت المتبقي وتنظيم استعداداتك بشكل أفضل!
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>أعياد الميلاد حول العالم</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  يحتفل الناس بأعياد الميلاد بطرق مختلفة حول العالم. إليك بعض
                  العادات والتقاليد المميزة:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  الدول العربية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>مصر:</strong> كعكة عيد ميلاد كبيرة وتجمع عائلي
                  </li>
                  <li>
                    <strong>السعودية:</strong> احتفالات عائلية وهدايا للأطفال
                  </li>
                  <li>
                    <strong>لبنان:</strong> حفلات كبيرة وديكورات فخمة
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  دول حول العالم:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>المكسيك:</strong> تقليد "La Piñata" - ضرب الدمية
                    المعلقة
                  </li>
                  <li>
                    <strong>البرازيل:</strong> سحب أذن صاحب عيد الميلاد بعدد
                    السنوات
                  </li>
                  <li>
                    <strong>الصين:</strong> تناول نودلز طويلة للعمر المديد
                  </li>
                  <li>
                    <strong>اليابان:</strong> احتفال بأعياد ميلاد معينة فقط (3،
                    5، 7)
                  </li>
                  <li>
                    <strong>هولندا:</strong> كعكة خاصة وكراسي مزينة
                  </li>
                  <li>
                    <strong>إيطاليا:</strong> سحب الأذن وقطع الكعكة الأول
                  </li>
                  <li>
                    <strong>روسيا:</strong> كعكة فطيرة بدلاً من الكعكة التقليدية
                  </li>
                  <li>
                    <strong>كندا:</strong> دهن أنف صاحب عيد الميلاد بالزبدة للحظ
                    الجيد
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  عادات مشتركة عالمياً:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>إطفاء الشموع على الكعكة</li>
                  <li>غناء أغنية عيد الميلاد</li>
                  <li>تقديم الهدايا</li>
                  <li>التقاط الصور التذكارية</li>
                  <li>التمني قبل إطفاء الشموع</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>نصائح لجعل عيد ميلادك مميزاً</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  نصائح عامة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>كن صادقاً مع نفسك:</strong> احتفل بالطريقة التي
                    تناسبك، لا بما يتوقعه الآخرون
                  </li>
                  <li>
                    <strong>ابدأ العد التنازلي مبكراً:</strong> استخدم حاسبتنا
                    لتتبع الوقت المتبقي
                  </li>
                  <li>
                    <strong>وثق اللحظات:</strong> التقط الكثير من الصور والفيديوهات
                  </li>
                  <li>
                    <strong>شارك الفرحة:</strong> دع الآخرين يشاركونك هذا اليوم
                    الخاص
                  </li>
                  <li>
                    <strong>كن ممتناً:</strong> قدّر وجود الأحباء في حياتك
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  لجعل يومك أكثر خصوصية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>ابدأ اليوم بنشاط تحبه</li>
                  <li>ارتدِ ملابس تشعرك بالثقة</li>
                  <li>افعل شيئاً لطيفاً لنفسك</li>
                  <li>تواصل مع الأشخاص المهمين في حياتك</li>
                  <li>تأمل في إنجازاتك خلال العام الماضي</li>
                  <li>ضع أهدافاً للعام القادم</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  نصائح للميزانية المحدودة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>احتفل في المنزل مع العائلة</li>
                  <li>اصنع الكعكة بنفسك</li>
                  <li>استخدم ديكورات منزلية بسيطة</li>
                  <li>اطلب من الضيوف المساهمة في الطعام</li>
                  <li>ركّز على الأجواء والمشاعر أكثر من المظاهر</li>
                </ul>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💝 تذكر:</strong> أهم شيء في عيد ميلادك هو أن تكون
                  سعيداً ومحاطاً بمن تحب!
                </div>
              </div>
            </div>
          </div>
          <br />
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            أسئلة متكررة
          </h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف أعرف كم باقي على عيد ميلادي؟
                </h3>
              </div>
              <div className="info-section-body">
                لمعرفة كم باقي على عيد ميلادك، اتبع هذه الخطوات البسيطة:
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>أدخل تاريخ ميلادك في الحقل المخصص</li>
                  <li>اضغط على زر "ابدأ العد التنازلي"</li>
                  <li>
                    ستظهر لك فوراً النتيجة بالأشهر والأيام والساعات والدقائق
                    والثواني
                  </li>
                  <li>
                    العداد سيتحدث تلقائياً كل ثانية ليعرض الوقت المتبقي بدقة
                  </li>
                </ol>
                إذا كان اليوم هو عيد ميلادك، ستظهر لك رسالة تهنئة خاصة!
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يتم تحديث العداد تلقائياً؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم، بمجرد أن تبدأ العد التنازلي، يتم تحديث العداد تلقائياً كل
                ثانية دون الحاجة لأي تدخل منك. هذا يعني أنك ستشاهد الوقت المتبقي
                يتناقص بشكل مباشر أمام عينيك، مما يعطيك تجربة عد تنازلي حقيقية
                ومشوقة. يمكنك ترك الصفحة مفتوحة ومشاهدة العداد يتحرك بشكل مستمر!
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ماذا يحدث إذا كان اليوم هو عيد ميلادي؟
                </h3>
              </div>
              <div className="info-section-body">
                إذا كان اليوم هو عيد ميلادك، ستظهر لك رسالة تهنئة خاصة مع رموز
                احتفالية (🎉 🎂). ستخبرك الرسالة بعمرك الجديد وتاريخ عيد ميلادك
                القادم في العام المقبل. هذه طريقة رائعة لبدء يومك الخاص بمفاجأة
                سارة! يمكنك أيضاً مشاركة لقطة شاشة من الرسالة مع أصدقائك
                وعائلتك للاحتفال معهم.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يمكنني استخدام الحاسبة لأعياد ميلاد الآخرين؟
                </h3>
              </div>
              <div className="info-section-body">
                بالتأكيد! يمكنك استخدام حاسبة العد التنازلي لعيد الميلاد لمعرفة
                كم باقي على أعياد ميلاد:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>أطفالك</li>
                  <li>زوجتك أو زوجك</li>
                  <li>والديك</li>
                  <li>أصدقائك المقربين</li>
                  <li>أي شخص تريد الاحتفال بعيد ميلاده</li>
                </ul>
                هذه طريقة رائعة للتخطيط المسبق للاحتفالات والتأكد من أنك لن تنسى
                عيد ميلاد أي شخص عزيز عليك!
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف أستفيد من معلومات العد التنازلي؟
                </h3>
              </div>
              <div className="info-section-body">
                معلومات العد التنازلي مفيدة جداً للتخطيط المسبق:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>إذا بقي شهر أو أكثر:</strong> ابدأ بالتخطيط
                    للاحتفال، حدد المكان، وضع قائمة بالمدعوين
                  </li>
                  <li>
                    <strong>إذا بقي أسبوعان:</strong> أرسل الدعوات، احجز المطعم
                    أو القاعة، اطلب الكعكة
                  </li>
                  <li>
                    <strong>إذا بقي أسبوع:</strong> اشترِ الديكورات
                    والمستلزمات، أكد الحجوزات
                  </li>
                  <li>
                    <strong>إذا بقيت أيام قليلة:</strong> حضّر التفاصيل
                    الأخيرة، نظّف المكان
                  </li>
                </ul>
                استخدم الحاسبة كمرجع للتأكد من أنك على المسار الصحيح في
                التحضيرات!
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل الحاسبة دقيقة؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم، حاسبة العد التنازلي دقيقة جداً. تستخدم الحاسبة:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>التاريخ والوقت الحالي من جهازك</li>
                  <li>حسابات دقيقة تأخذ في الاعتبار السنوات الكبيسة</li>
                  <li>تحديث تلقائي كل ثانية</li>
                  <li>معادلات برمجية متطورة</li>
                </ul>
                الدقة مضمونة حتى مستوى الثانية، لذا يمكنك الاعتماد على النتائج
                بثقة تامة. العداد يعرض الوقت المتبقي بدقة تامة من اللحظة الحالية
                حتى منتصف ليلة عيد ميلادك (الساعة 00:00).
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  لماذا من المهم معرفة كم باقي على عيد الميلاد؟
                </h3>
              </div>
              <div className="info-section-body">
                معرفة الوقت المتبقي على عيد ميلادك مهم لعدة أسباب:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>التخطيط المسبق:</strong> يمنحك وقتاً كافياً
                    للتحضيرات
                  </li>
                  <li>
                    <strong>التحفيز:</strong> يخلق شعوراً بالترقب والإثارة
                  </li>
                  <li>
                    <strong>عدم النسيان:</strong> يذكّرك بالمناسبة الهامة
                  </li>
                  <li>
                    <strong>المشاركة:</strong> يمكنك مشاركة العد التنازلي مع
                    الآخرين
                  </li>
                  <li>
                    <strong>التنظيم:</strong> يساعدك على جدولة الاستعدادات بشكل
                    أفضل
                  </li>
                </ul>
                العد التنازلي يضيف عنصر المتعة والترقب لأي احتفال!
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يمكنني حفظ العد التنازلي؟
                </h3>
              </div>
              <div className="info-section-body">
                يمكنك بسهولة:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>حفظ الصفحة في المفضلة:</strong> لتعود إليها في أي
                    وقت
                  </li>
                  <li>
                    <strong>التقاط صورة للشاشة:</strong> لمشاركتها مع الأصدقاء
                  </li>
                  <li>
                    <strong>إضافة الصفحة للشاشة الرئيسية:</strong> لسهولة
                    الوصول على الهاتف
                  </li>
                  <li>
                    <strong>مشاركة رابط الحاسبة:</strong> مع من تحب للاحتفال
                    معاً
                  </li>
                </ul>
                الحاسبة متاحة لك في أي وقت ومن أي جهاز، كل ما تحتاجه هو إعادة
                إدخال تاريخ الميلاد لبدء العد التنازلي من جديد.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AgeCalculatorGregorian;